import { createSlice } from '@reduxjs/toolkit'
import { ResponseDataBody } from 'src/types/websocket'

type moSvgNameType = 'mo_battery_full' | 'mo_battery_half' | 'mo_battery_zero'
type pcSvgNameType = 'pc_battery_full' | 'pc_battery_half' | 'pc_battery_zero'

export type BatteryDataType = ResponseDataBody.Battery & {
  SvgName: { mo: moSvgNameType; pc: pcSvgNameType }
}

const initialState: BatteryDataType = {
  BatteryInfo: null,
  SvgName: { mo: 'mo_battery_zero', pc: 'pc_battery_zero' },
}

const batterySlice = createSlice({
  name: 'isBattery',
  initialState,
  reducers: {
    setBatteryInfo(state, action) {
      state.BatteryInfo = action.payload.BatteryInfo
      state.SvgName = BatterySvgController(state.BatteryInfo)
    },
  },
})

const BatterySvgController = (
  batteryInfo: number | null,
): { mo: moSvgNameType; pc: pcSvgNameType } => {
  switch (true) {
    case batteryInfo === 100:
      return { mo: 'mo_battery_full', pc: 'pc_battery_full' }
    case batteryInfo && 0 < batteryInfo:
      return { mo: 'mo_battery_half', pc: 'pc_battery_half' }
    default:
      return { mo: 'mo_battery_zero', pc: 'pc_battery_zero' }
  }
}
export const { setBatteryInfo } = batterySlice.actions

export default batterySlice.reducer
